import React from 'react';
import breeds from '../../statics/breeds.json';
import Autocomplete from '@mui/material/Autocomplete';
import { TextField } from '@mui/material'
import { useContext } from 'react';
import { GlobalDataContext } from '../../hooks/DataContext';



function getBreedByID(breed_id) {
  return breeds.filter(
    function (breeds) {
      return breeds.nr === parseInt(breed_id)
    }
  );
}


export default function AnimalRaceFilter(props) {

  const setBreed = props.setBreed;
  const breed = props.breed;

  var selected_breeds = breed;


  const breedOptions = useContext(GlobalDataContext);


  if (selected_breeds != null) {
    selected_breeds = selected_breeds.split(',')
    selected_breeds = [...selected_breeds].map(c => getBreedByID(c))
    selected_breeds = selected_breeds.map(x => x[0])
  } else {
    selected_breeds = []
  }


  function saveInput(event, option, reason) {
    //Saves the selection if the user. Null if the user deletes the selection. Only one selection allowed.
    var text = null
  
    if (option !== null) {
  
      text = option.nr.toString()

      if (text === '') {
        text = null
      }
    }
    setBreed(text)
  }

  function buildBreedString(option) {
    var breed_string = option.breed
    if (option.anzahl !== null && option.anzahl !== undefined) {
      breed_string = breed_string + ' (' + option.anzahl + ')'
    }
    return breed_string
  }

  return (<>

    <Autocomplete
      fullWidth={true}
      onChange={saveInput}
      multiple={false}
      options={breedOptions}
      defaultValue={[...selected_breeds][0]}
      getOptionLabel={buildBreedString}
      filterSelectedOptions
      renderInput={(params) => (<TextField {...params} label="Hunderasse" />)}
    />
  </>
  );
}